import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { bookingShape, userShape } from 'constants/propTypes';
import { Column, Page, Row } from 'components/shared/Layout';
import BookingPathReviewBookingSummary from 'components/ui/BookingPathReviewBookingSummary';
import BookingPathReviewBookingCTA from './BookingPathReviewBookingCTA';

const BookingPathReviewBooking = ({ user, booking, refetch }) => {
  const { currency, pendingCreationLegs = [] } = booking;
  const displayContactEBSCAssistance =
    pendingCreationLegs.length > 0 &&
    pendingCreationLegs.some(({ extraProducts }) => extraProducts.find(({ provisional, type }) => provisional && type === 'DS'));

  return (
    <Page data-cy="review-booking">
      <Row span={14} start={2} noGutter>
        <Column start={1} span={10}>
          <h1>
            <FormattedMessage id="bookingPath.reviewBooking" />
          </h1>
        </Column>
      </Row>

      <Row span={14} start={2}>
        <BookingPathReviewBookingSummary
          user={user}
          title="summary.BookingSummary"
          booking={booking}
          refetch={refetch}
          currency={currency}
          displayContactEBSCAssistance={displayContactEBSCAssistance}
        />
        <BookingPathReviewBookingCTA bookingData={booking} user={user} />
      </Row>
    </Page>
  );
};

BookingPathReviewBooking.propTypes = {
  user: userShape.isRequired,
  booking: bookingShape.isRequired,
  refetch: PropTypes.func.isRequired
};

export default BookingPathReviewBooking;
